
import { Component, Ref, Vue } from 'vue-property-decorator'
import ModalPassword from '@/components/templates/manage/ModalPassword.vue'
import PasswordUtils from '@/utils/PasswordUtils'
import { TemporaryUsersApi } from '@/api/methods/manage/TemporaryUsersApi'

/**
 * 仮ユーザパスワード変更モーダル
 */
@Component({
  components: {
    ModalPassword,
  },
})
export default class ModalEditTemporaryPassword extends Vue {
  /** パスワード変更モーダルのフォーマット */
  @Ref()
  modalPassword!: ModalPassword

  /** 変更対象の仮ユーザID */
  private temporaryUserId: number = 0

  /**
   * 送信ボタンのdisabled制御
   *
   * @param newPassword パスワード
   * @param confirm 確認用パスワード
   * @returns 未入力があった場合はtrue
   */
  private submitDisabled(newPassword: string, confirm: string): boolean {
    // パスワードが未入力の場合true
    if (!newPassword) {
      return true
    }

    // 確認用パスワードが未入力の場合true
    if (!confirm) {
      return true
    }

    return false
  }

  /**
   * 変更ボタン押下時の処理
   */
  private async submitPassword(): Promise<void> {
    this.$loading.start()

    let errorMessage = null

    // パスワードのバリデーションチェック
    errorMessage = this.validPassword()
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // パスワード指定が適切かのチェック
    errorMessage = PasswordUtils.checkPasswordEnabled(this.modalPassword.newPassword)
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // パスワード更新
    await TemporaryUsersApi.updateUserPassword(this.temporaryUserId, this.modalPassword.newPassword)

    this.$loading.complete()

    // モーダルを閉じる
    this.hide()
  }

  /**
   * パスワードのバリデーションチェック
   *
   * @returns 確認用パスワードと一致しない場合エラーメッセージを返す
   */
  public validPassword(): string | null {
    if (this.modalPassword.newPassword !== this.modalPassword.confirm) {
      return '新規パスワードと確認用パスワードが一致しません'
    }

    return null
  }

  /**
   * モーダルを開く
   *
   * @param temporaryUserId 仮ユーザID
   */
  public show(temporaryUserId: number): void {
    this.temporaryUserId = temporaryUserId
    this.modalPassword.show()
  }

  /**
   * モーダルを閉じる
   */
  private hide(): void {
    this.modalPassword.hide()
  }
}
